import React from "react";
import * as ImageHelper from "../../framework/helpers/ImageHelper";
import { Article } from "./components/";
import { Paragraph } from "../../BaseComponents/Text";
import media from "styled-media-query";
import breakpoints from "Helpers/BreakpointHelper";
import { BlockContainer } from "BaseComponents/Wrappers";
import { useGlobal } from "reactn";

import styled from "styled-components";
import { HeaderLink } from "BaseComponents/Link";

export const ArticleBlockContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.bg1};
  padding: 0 3rem;

  ${media.lessThan(breakpoints.ipad)`
  padding: 1rem 1rem;
  
  `}
  ${media.lessThan(breakpoints.mobile)`
  padding: 0;

  `}
`;
export const ArticleBlockOuterWrapper = styled.div`
  max-width: ${({ theme }) => theme.grid.outer};
  width: auto;
  padding: 0 1rem;

  ${media.greaterThan(breakpoints.mobile)`
        margin: 0 auto;
        width: auto;
    `}
`;

export const ArticleBlockWrapper = styled.div.attrs(({ direction }) => ({
  flexDirection: direction ? direction : "row",
}))`
  width: auto;
  display: flex;
  gap: 15px;
  flex-direction: ${({ flexDirection }) => flexDirection};
  ${media.lessThan(breakpoints.mobile)`
        flex-direction: column;
    `};
`;

export const ArticleBlock = ({
  Heading,
  HeadingUrl,
  SearchHits,
  PriorityNews,
}) => {
  const [theme] = useGlobal("theme");

  return (
    SearchHits.length > 0 && (
      <BlockContainer bgColor={theme.colors.lightgrey}>
        <ArticleBlockOuterWrapper>
          {(HeadingUrl || Heading) && (
            <HeaderLink
              inline
              margin="0 0 2rem 0rem"
              marginsmall="0 0 1rem 0"
              text={Heading}
              size="h2"
              href={HeadingUrl}
              color="black"
              arrow={true}
            />
          )}
          <ArticleBlockWrapper direction="column">
            {PriorityNews?.Url && (
              <ArticleBlockWrapper>
                <Article
                  {...PriorityNews}
                  isPriority={true}
                  key={`article-block-priority-0`}
                />
              </ArticleBlockWrapper>
            )}
            <ArticleBlockWrapper>
              {SearchHits.map((article, i) => {
                return <Article {...article} key={`article-block-${i}`} />;
              })}
            </ArticleBlockWrapper>
          </ArticleBlockWrapper>
        </ArticleBlockOuterWrapper>
      </BlockContainer>
    )
  );
};
